import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL;


export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/agents/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error === "Invalid email or password" ? "Неверный логин или пароль" : "Ошибка авторизации";
        console.log(errorMessage, 'errorMessage')
        return rejectWithValue(errorMessage);
      }

      const data = await response.json();
      const { access_token, refresh_token, agent_id } = data;


      const isSuperAdmin =
        userData.email === "super_admin" && userData.password === "super_admin";
      const role = isSuperAdmin ? "super_admin" : "agent";


      localStorage.setItem("email", userData.email);
      localStorage.setItem("password", userData.password);
      localStorage.setItem("token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      localStorage.setItem("agent_id", agent_id);
      localStorage.setItem("role", role);

      return { token: access_token, refresh_token, agent_id, role };
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);


export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        return rejectWithValue("Нет токена для выхода");
      }

      const response = await fetch(`${API_URL}/api/v1/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage =
          responseDataError.error?.Message || "Ошибка выхода";
        return rejectWithValue(errorMessage);
      }


      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("email");
      localStorage.removeItem("role");
      localStorage.removeItem("agent_id");

      return true;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    error: null,
    token: localStorage.getItem("token") || null,
    refresh_token: localStorage.getItem("refresh_token") || null,
    agent_id: localStorage.getItem("agent_id") || null,
    role: localStorage.getItem("role") || null,
    isAuthenticated: !!localStorage.getItem("token"),
  },
  reducers: {
    logout(state) {
      state.token = null;
      state.refresh_token = null;
      state.agent_id = null;
      state.role = null;
      state.isAuthenticated = false;

      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      localStorage.removeItem("role");
      localStorage.removeItem("agent_id");

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.token = action.payload.token;
        state.refresh_token = action.payload.refresh_token;
        state.agent_id = action.payload.agent_id;
        state.role = action.payload.role;
        state.isAuthenticated = true;
        state.loading = false;
      })

      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
      })
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.refresh_token = null;
        state.agent_id = null;
        state.role = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
